import type { SiteMapEntry, SiteMapHealth, SiteMapSites } from '../models/siteMapModels';

/**
 * Joins listed sites with their health by siteId, in site list order.
 * Health for unlisted sites is ignored; see findUnmatchedHealth.
 */
export function joinSiteMap(
  sites: SiteMapSites,
  health: SiteMapHealth | null
): readonly SiteMapEntry[] {
  const healthById = new Map((health?.sites ?? []).map((h) => [h.siteId, h] as const));
  return sites.sites.map((site) => {
    const siteHealth = healthById.get(site.siteId);
    return siteHealth ? { site, health: siteHealth } : { site };
  });
}

/**
 * Health site ids missing from the site list. Both endpoints come from one snapshot, so a
 * mismatch means the site list is older than the health and should be reloaded.
 */
export function findUnmatchedHealth(
  sites: SiteMapSites,
  health: SiteMapHealth
): readonly string[] {
  const listed = new Set(sites.sites.map((site) => site.siteId));
  return health.sites.map((h) => h.siteId).filter((siteId) => !listed.has(siteId));
}
